export default "__VITE_ASSET__CEMyEWFC__";